// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.administration__container {
    box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
    border-radius: 4px;
    text-align: left;
    background: #ffffff;
    height: fit-content;
}

.administration__details__wrapper {
    width: 100%;
    box-shadow: none;
}

.administration__details__title {
    color: var(--primary);
    font-weight: 600;
    padding: 10px 14px 0;
    font-size: var(--title);
    margin: 0;
}

.administration__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 14px;
    gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/Administration/clientManagementTab/ClientManagement.css"],"names":[],"mappings":"AAAA;IACI,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ","sourcesContent":[".administration__container {\n    box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n    border-radius: 4px;\n    text-align: left;\n    background: #ffffff;\n    height: fit-content;\n}\n\n.administration__details__wrapper {\n    width: 100%;\n    box-shadow: none;\n}\n\n.administration__details__title {\n    color: var(--primary);\n    font-weight: 600;\n    padding: 10px 14px 0;\n    font-size: var(--title);\n    margin: 0;\n}\n\n.administration__footer {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 12px 14px;\n    gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
